import {NodeEvent, NodeEventType} from "./flowEvent";

export interface ActionEvent extends NodeEvent {
    nodeEventType: NodeEventType;
    result: string;
    name: string;
    description: string;
    params: { [index: string]: any };
    resolveParams: { [index: string]: any };
}

export interface MenuDisplayEvent extends NodeEvent {
    nodeEventType: NodeEventType;
    resolvedDisplay: string;
}

export interface MenuInputEvent extends NodeEvent {
    nodeEventType: NodeEventType;
    inputType: string;
    name: string;
    result: string;
    input: { [index: string]: any };
}
